const prefix = 'cvf-admin/modal/';

export const SHOW_MODAL = `${prefix}SHOW_MODAL`;
export const HIDE_MODAL = `${prefix}HIDE_MODAL`;
